import { DEFAULT_LATEST } from 'constants/dateLimits';
import { MilitaryDisciplinaryProceduresItemModel } from 'forms/sections/military/disciplinary/types';
import { DateModel, ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';

const militaryDisciplinaryProceduresItemValidator: ValidateJSModel<MilitaryDisciplinaryProceduresItemModel> = {
  Date: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { requireDay: false, earliest: setToStartOfMonth(options?.applicantBirthdate) as DateModel, latest: DEFAULT_LATEST },
  }),

  Offenses: { hasValue: true },

  Name: { hasValue: true },

  Court: { hasValue: true },

  Outcome: { hasValue: true },

  Comments: {},
};

export default militaryDisciplinaryProceduresItemValidator;
